import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import parseHTML from 'html-react-parser';
import { addExtraParamsToUrl } from './helpers';
import { wrapScriptTags } from '../../../Code/helpers';
import { VIDEO_WRAPPER_CLASS_NAME } from '../../../../constants';
const VimeoProvider = ({
  url,
  autoplay,
  loop,
  imageData
}) => {
  const inputEl = useRef(null);
  const [videoData, setVideoData] = useState(null);
  const [videoError, setVideoError] = useState(null);
  const [shouldRenderVideo, setShouldRenderVideo] = useState(!!autoplay);
  useEffect(() => {
    async function fetchVideoData(videoUrl) {
      try {
        const res = await fetch(videoUrl);
        const data = await res.json();
        setVideoData(data);
      } catch (err) {
        setVideoError(err);
      }
    }
    if (url) {
      const currentHeight = inputEl.current.clientHeight;
      const urlWithParams = addExtraParamsToUrl(url, {
        autoplay: true,
        loop,
        height: currentHeight
      });
      fetchVideoData(urlWithParams);
    }
  }, [autoplay, loop, url]);
  const {
    thumbnail_url_with_play_button: thumbnailUrl,
    html = ''
  } = videoData || {};
  const imageUrl = imageData && imageData.url;
  const backgroundUrl = imageUrl || thumbnailUrl;
  const videoStyle = {};
  if (!shouldRenderVideo && backgroundUrl) videoStyle.backgroundImage = `url(${!shouldRenderVideo ? backgroundUrl : ''})`;
  if (inputEl && inputEl.current) videoStyle.maxheight = inputEl.current.clientHeight;
  const parsedCode = parseHTML(html);
  const wrappedCode = wrapScriptTags(parsedCode);
  return /*#__PURE__*/React.createElement("div", {
    ref: inputEl,
    role: "button",
    className: VIDEO_WRAPPER_CLASS_NAME,
    style: videoStyle,
    "aria-label": "Open video",
    onClick: () => !shouldRenderVideo && setShouldRenderVideo(true)
  }, shouldRenderVideo && !videoError && wrappedCode, videoError && videoError.message);
};
VimeoProvider.propTypes = {
  url: PropTypes.string.isRequired,
  autoplay: PropTypes.bool,
  loop: PropTypes.bool,
  imageData: PropTypes.object
};
VimeoProvider.defaultProps = {
  autoplay: false,
  loop: false,
  imageData: null
};
export default VimeoProvider;
//# sourceMappingURL=VimeoProvider.js.map